import memoize from 'memoizee'

export const isFeatureDisabled = memoize((state, feature) => state.features.flags.findIndex(f => f === feature) !== -1)
export const isFeatureEnabled = memoize((state, feature) => state.features.flags.findIndex(f => f === feature) === -1)
